<template>
    <div class="wrap" v-loading="sendingData">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        스토어 상세
                        <div class="clear"></div>
                    </div>
                    <div class="c_table_wrap">
                        <table>
                            <colgroup>
                                <col width="200px;">
                                <col width="">
                            </colgroup>
                            <tr>
                                <td class="c_t_title">노출 상태</td>
                                <td colspan="3">
                                    <div>
                                        <el-radio-group v-model="display">
                                            <el-radio :label="1">노출</el-radio>
                                            <el-radio :label="0">노출안함</el-radio>
                                        </el-radio-group>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="c_t_title">스토어 명</td>
                                <td colspan="3">
                                    <div>
                                        <el-input v-model="title"></el-input>
                                        <div class="input_error">{{ validation.firstError('title') }}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="c_t_title">메인 이미지</td>
                                <td colspan="3">
                                    <div @click="UploadFlagChange('mainImage')" class="stori_title">
                                        <el-upload
                                            ref="UserImg"
                                            class="avatar-uploader"
                                            action=""
                                            list-type="picture-card"
                                            :auto-upload="false"
                                            :show-file-list="false"
                                            :file-list="mainImage"
                                            :on-change="handleFileChange"

                                        >
                                            <!-- <el-button size="mini" type="primary">+등록</el-button> -->
                                            <i class="el-icon-plus avatar-uploader-icon"
                                               v-if="mainImage.length === 0"></i>
                                            <div v-else>
                                                <img
                                                    :src="mainImage[0].org_url ? mainImage[0].org_url : mainImage[0].url"
                                                    alt="" class="avatar">
                                            </div>
                                        </el-upload>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td class="c_t_title">링크</td>
                                <td colspan="3">
                                    <div>
                                        <el-input v-model="link"></el-input>
                                        <div class="input_error">{{ validation.firstError('link') }}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="c_t_title">최소 전환가능 포인트</td>
                                <td colspan="3">
                                    <div>
                                        <el-input v-model="minPoint"></el-input>
                                        <div class="input_error">{{ validation.firstError('minPoint') }}</div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="text_center mt15">
                        <el-button type="primary" @click="submitForm()">저장</el-button>
                        <el-button type="danger" @click="runDelete()">스토어 삭제</el-button>
                    </div>
                    <div class="title">
                        포인트 지급 내역
                        <div class="clear"></div>
                    </div>
                    <div class="table_wrap">
                        <div class="table_search row has_bc">
                            <el-row>
                                <el-col :span="19" class="text_right">
                                    <div class="store_point_wrap">
                                        <div class="store_point apply">전환신청 : {{ returnApplyPoint() }}p</div>
                                        <div class="store_point reject">전환반려 : {{ returnRejectPoint() }}p</div>
                                        <div class="store_point total">총 전환 : {{ returnTotalPoint() }}p</div>
                                    </div>
                                </el-col>
                                <el-col class="text_right" :span="5">
                                    <el-select
                                        v-model="pageRow"
                                        @change="getPointList"
                                    >
                                        <el-option
                                            v-for="row in pageRows"
                                            :key="row"
                                            :label="`${row}개 씩보기`"
                                            :value="row"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            :data="ApiData"
                            style="width: 100%"
                            empty-text="데이터가 없습니다."
                            @cell-click="cellClick"
                            v-loading="tableLoading"
                        >
                            <el-table-column
                                class="table_no"
                                type="index"
                                label="#"
                                width="70"
                                class-name="num"
                                :index="tableIndex"
                            >
                            </el-table-column>

                            <el-table-column
                                v-for="(header, index) in tableHeader"
                                :key="index"
                                :label=header.label
                                :width=header.width
                                :sortable="header.sortable"
                                :class-name="`${header.class}`"
                                :cell="header.prop"
                                :prop="header.sortProp"
                            >
                                <template slot-scope="scope">
                                    <div>
                                        <span v-if="header.prop === 'pbs_status'"
                                              v-html="$_.result(scope.row, header.prop) === 0 ? '포인트 전환 신청' : $_.result(scope.row, header.prop) === 1 ? '포인트 전환 보류':$_.result(scope.row, header.prop) === 2 ? '포인트 전환 거절':$_.result(scope.row, header.prop) === 3 ? '포인트 전환 승인':'-'">

                                        </span>
                                        <span v-else-if="header.prop === 'p_point'"
                                              v-html="Math.abs($_.result(scope.row, header.prop))">

                                        </span>
                                        <span
                                            v-else
                                            v-html="$_.result(scope.row, header.prop) ? $_.result(scope.row, header.prop) : isNaN($_.result(scope.row, header.prop)) || $_.result(scope.row, header.prop) === null || $_.result(scope.row, header.prop) === '' ? '-' : $_.result(scope.row, header.prop)"
                                        >
                                        </span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagnation_wrap">
                            <el-pagination
                                v-show="apiPage.total > 0"
                                :page-size=pageRow
                                :pager-count=11
                                layout="prev, pager, next"
                                :current-page.sync=page
                                :page-sizes="[10, 30, 50]"
                                :total="apiPage.total"
                                @current-change="getPointList"
                            >
                            </el-pagination>

                        </div>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>


        </div>
    </div>
</template>

<script>
import VuxAlert from '@/mixins/alertMixins';
import util from '@/mixins/util';
import localStorage from '@/mixins/localStorage'
import SimpleVueValidation from 'simple-vue-validator';
import List from '@/mixins/List'

const Validator = SimpleVueValidation.Validator;
import Vue from 'vue';
import {mapState} from "vuex";

Vue.use(SimpleVueValidation);


let params = {};
export default {
    name: 'StoreDetail',
    components: {},
    mixins: [VuxAlert, localStorage, List],
    data() {
        return {
            title: '',
            link: '',
            minPoint: '',
            sendingData: false,
            mainImage: [],
            tableData: [],
            tableSearch: '',
            tableLoading: true,
            filterDate: '',
            tableHeader: [
                {
                    label: '신청번호',
                    prop: 'pbs_code',
                    sortable: false,
                    class: 'text_center',
                    width: 85
                }, {
                    label: '아이디',
                    prop: 'mb_id',
                    sortable: false,
                    class: 'text_center',
                },
                {
                    label: '이름 / 닉네임',
                    prop: 'mb_nick',
                    sortable: false,
                    class: 'text_center',
                    width: 100,
                },
                {
                    label: '인증메일',
                    prop: 'sm_email',
                    sortable: false,
                    class: 'text_center',
                },
                {
                    label: '상세내용',
                    prop: 'pbs_status',
                    sortable: false,
                    class: 'text_center',
                },
                {
                    label: '전환액',
                    prop: 'p_point',
                    sortable: false,
                    class: 'text_center',
                    width: 90,
                },
                {
                    label: '일자',
                    prop: 'created_at',
                    sortable: false,
                    class: 'text_center',
                    width: 150,
                },
                {
                    label: '승인관리자',
                    prop: 'adm_name',
                    sortable: false,
                    class: 'text_center',
                },

            ],
            tableoption: true,
            pageRows: [10, 30, 50],
            selectRow: [],
            s_idx: this.$route.params.s_idx,
            display: 1,
            pointTotal: [],
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        link: function (value) {
            return Validator.value(value)
                .required('링크를 입력해주세요.')
        },
        minPoint: function (value) {
            return Validator.value(value)
                .required('최소 전환가능 포인트를 입력해주세요.')
                .integer('숫자만 입력 가능합니다.')
        },
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === "/auth" && this.$localStorage.get('token')) {
            next(false);
        } else {
            return next();
        }
    },
    created() {
    },
    mounted() {
        this.getDetail()
        this.getPointList();
        this.getTotalPoint();
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        getDetail() {
            if (this.s_idx) {
                let params = {
                    ip: 0,
                    id: this.s_idx,
                    opp: 1,
                    opf: 1
                }
                this.$api.$store.getStoreList(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.title = res.List[0].s_name;
                        this.mainImage = res.List[0].File;
                        this.link = res.List[0].s_link;
                        this.minPoint = res.List[0].s_point;
                        this.display = res.List[0].s_display;
                    }
                });
            }
        },
        submitForm() {
            let validateArr = ['title', 'link', 'minPoint'];
            this.$validate(validateArr).then((success) => {
                if (success) {
                    this.sendingData = true;
                    let params = {
                        s_idx: this.s_idx,
                        s_name: this.title,
                        s_link: this.link,
                        s_point: this.minPoint,
                        s_display: this.display,
                    }
                    try {
                        this.$api.$store.updateStore(params).then(res => res.Data.Result).then(res => {
                            let type = this.returnCreateType(res.Info.Type)
                            if (type === true) {
                                if (!util.isEmpty(this.mainImage) && this.mainImage[0].hasOwnProperty('raw')) {
                                    this.uploadFile(this.mainImage, 'store', this.s_idx);
                                } else {
                                    this.sendingData = false;
                                    this.createAlert({
                                        title: '',
                                        content: '스토어가 등록 되었습니다.',
                                        btnText: '확인',
                                        back: true
                                    })
                                }
                            } else {
                                this.sendingData = false;
                                this.errorAlert(type);
                            }
                        })
                    } catch (e) {
                        this.sendingData = false;
                        console.log(e)
                    }

                } else {
                    this.validateAlert();
                }
            });
        },
        returnCreateType(type) {
            switch (type) {
                case 1 :
                    return true
                case -100 :
                    return '필수값이 없습니다.'
                default :
                    return '등록에 실패했습니다.'

            }

        },
        uploadFile(fileList, type, id) {
            let formData = new FormData;
            formData.append('files', fileList[0].raw);
            formData.append('a_container_type', type);
            formData.append('a_container_id', id);
            if (fileList[0].a_idx) {
                formData.append('a_idx', fileList[0].a_idx);
            }
            return this.$api.$common.updateFile(formData).then(res => res.Data.Result).then(res => {
                this.sendingData = false
                if (res.Info.status) {
                    this.createAlert({
                        title: '',
                        content: '스토어가 등록 되었습니다.',
                        btnText: '확인',
                        back: true,
                    })
                } else {
                    this.errorAlert("메인 이미지 등록에 실패했습니다.");
                }
            })
        },
        handleFileChange(file, fileList) {
            let maxSize = 1024 * 1024 * 20;
            let type = file.raw.type.split('/');
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                this.MoveFileList(file)
            }
        },
        UploadFlagChange(flag) {
            this.UploadFlag = flag
        },
        MoveFileList(file) {
            switch (this.UploadFlag) {
                case 'mainImage':
                    if (this.mainImage.length > 0 && this.mainImage[0].hasOwnProperty('a_idx')) {
                        file.a_idx = this.mainImage[0].a_idx;
                    }
                    this.mainImage[0] = file;
                    this.$forceUpdate();
                    break;
            }

        },
        getPointList() {
            this.tableLoading = true;

            params = {
                ip: 1,
                sp: this.pageRow,
                page: this.page,
                sid: this.$route.params.s_idx
            }
            if (!util.isEmpty(this.filterDate) && this.filterDate.length > 0) {
                params.crsd = this.filterDate[0];
                params.cred = this.filterDate[1];
            }
            if (this.tableSearch != '') {
                params.na = this.tableSearch;
            }
            this.getApiResult(this.$api.$point.getStorePoint(params));
        },

        changeFilterDate(date) {
            if (date === 'today') {
                this.filterDate = [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')];
            } else if (date === 'week') {
                this.filterDate = [this.$moment().add(-1, 'w').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            } else if (date === 'month') {
                this.filterDate = [this.$moment().add(-1, 'M').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            } else if (date === 'year') {
                this.filterDate = [this.$moment().add(-1, 'y').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            } else if (date === '') {
                this.filterDate = null;
            }
        },
        sortChange({column, prop, order}) {
            this.page = 1;
            let sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : "";
            this.setSort(prop, sortOrder)
        },
        goDetail(index, row) {
            this.MoveChild("/info/store/" + row.s_idx)
        },
        runDelete() {
            let alertParams = {'element': this, 'key': this.s_idx, id: this.UserInfo.mb_id};
            this.storeDeleteInputConfirm(alertParams)
        },
        dataDelete(key, pwd) {
            let params = {
                s_idx: key,
                pwd: pwd
            }
            try {
                this.$api.$store.deleteStore(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnDeleteType(res.Info.Type)
                    if (type !== true) {
                        this.errorAlert(type)
                    } else {
                        this.createAlert({
                            title: '',
                            content: '스토어가 삭제되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back()
                            }
                        })
                    }
                })
            } catch (e) {
                console.log(e)
            }

        },
        returnDeleteType(type) {
            switch (type) {
                case 1:
                    return true;
                case -100:
                    return '필수값이 없습니다.';
                case -103:
                    return '스토어가 없습니다.';
                case -300:
                    return '비밀번호가 일치하지 않습니다.';
                default:
                    return '스토어 삭제에 실패하였습니다. 잠시후 다시 시도 해주세요.';
            }
        },
        getTotalPoint() {
            let params = {
                sid: this.s_idx
            }
            try {
                this.$api.$point.getStorePointTotal(params).then(res => res.Data.Result).then(res => {
                    this.pointTotal = res.List
                })
            } catch (e) {
                console.log(e)
            }
        },
        returnApplyPoint() {
            let point = 0
            util.Array.each(this.pointTotal,(obj, index, arr) => {
                point = point + Number(obj.p_point)
            })
            return Math.abs(point)
        },
        returnRejectPoint() {
            let point = 0
            util.Array.each(this.pointTotal,(obj, index, arr) => {
                if(obj.pbs_status === 2){
                    point = point + Number(obj.p_point)
                }
            })
            return Math.abs(point)
        },
        returnTotalPoint() {
            let point = 0
            util.Array.each(this.pointTotal,(obj, index, arr) => {
                if(obj.pbs_status === 3){
                    point = point + Number(obj.p_point)
                }
            })
            return Math.abs(point)
        },

    },
    watch: {},

}
</script>
